module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av610-f4db176abffd8a46edf1fdccd6df404a.jpg";